import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const LoadingWrapper = styled(Grid)`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;